// TODO I6.5 to remove after merge with I6

/**
 * Keys for user data flags from /api/v1/current_user/ (use with userDataStorage.get()).
 * Values are booleans set by the backend: is_asset_owner, is_delegated.
 */
const USER_DATA_FLAGS = {
  IS_ASSET_OWNER: 'is_asset_owner',
  IS_DELEGATED: 'is_delegated',
  CAN_MANAGE_PROCESSING_ACTIVITIES: 'can_manage_processing_activities',
};

const ROLES = {
  PS_ROLES: {
    CONTENT_EDITOR: 'pocketsafe_content_editor',
    CUSTOMER_ADMINISTRATOR: 'pocketsafe_customer_administrator',
    CUSTOMER_EXIT_ADMINISTRATOR: 'PocketSafe Customer Exit Administrator',
    SECURITY_ONLINE: 'pocketsafe_security_online',
    SECURITY_SUPERVISOR: 'pocketsafe_security_supervisor',
  },
  USER_DATA_FLAGS,
  ORGANIZATION: {
    ACCOUNT_OWNER: 0,
    INCIDENT_MANAGER: 1,
    USER_ADMINISTRATOR: 2,
    SECURITY_OFFICER: 3,
    CONTRACT_ADMINISTRATOR: 4,
    ACTIVE_USER: 5,
    ASSETS_MANAGER: 6,
    EMERGENCY_BUTTON: 7,
    ASSET_TASK_DASHBOARD_ACCESS: 8,
    ASSET_RISK_DASHBOARD_ACCESS: 9,
    ASSET_RISK_TASK_DASHBOARD_ACCESS: 10,
    MANAGEMENT_DASHBOARD_ACCESS: 11,
    ADD_MANAGEMENT_DASHBOARD_ACCESS: 12,
    ACTION_LIBRARY_ADMINISTRATOR: 13,
    DASHBOARD_ASSET_RELATED_ACTIONS: 14,
    DSAR_ADMINISTRATOR: 15,
    ROPA_ADMINISTRATOR: 16,
  },
};

export default ROLES;
